export default __webpack_public_path__ + "static/media/artboard-4.6fa173bf.png";